<template>
	<div class="user-center-container">
		<div class="user-center-header filter-container">
			<!-- 搜索条件区域 -->
			<div class="search-container">
				<div class="search-form">
					<div class="form-item">
						<span class="label">权益类型</span>
						<el-select v-model="searchForm.memberBenefit" placeholder="请选择权益类型" filterable clearable>
							<el-option
								v-for="item in benefitsTypeDict"
								:key="item.dictCode"
								:label="item.dictValue"
								:value="item.dictCode"
							></el-option>
						</el-select>
					</div>
					<div class="form-item">
						<span class="label">开始时间</span>
						<el-date-picker
							v-model="searchForm.startTime"
							type="date"
							placeholder="选择开始日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</div>
					<div class="form-item">
						<span class="label">结束时间</span>
						<el-date-picker
							v-model="searchForm.endTime"
							type="date"
							placeholder="选择结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</div>
					<div class="form-buttons">
						<el-button type="primary" @click="handleSearch">搜索</el-button>
						<el-button @click="handleResetSearch">重置</el-button>
					</div>
				</div>
			</div>
		</div>

		<div class="user-center-content">
			<div class="link">
				<router-link target="_blank" to="/recordRemark" class="term-link">会员权益使用记录说明</router-link>
			</div>
			<!-- 列表区域 -->
			<data-table
				:table-data="recordList"
				:column="columns"
				:page-options="pageOptions"
				:border="true"
				:loading="loading"
				@page-change="handlePaginationChange"
			>
				<!-- <template slot="benefit_type" slot-scope="data">
					{{ getBenefitTypeName(data.scope.row.memberBenefit) }}
				</template> -->
			</data-table>
		</div>
	</div>
</template>

<script>
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { queryMemberBenefitUseRecord } from '@/api/memberBenefit/index'
	import { mapDictionaries } from '@/store/dictionary-helper'

	export default {
		name: 'MemberBenefitsRecord',
		components: {
			DataTable
		},
		props: {},
		data() {
			return {
				// 搜索表单
				searchForm: {
					memberBenefit: '',
					startTime: '',
					endTime: ''
				},
				// 记录列表
				recordList: [],
				columns: [
					// { label: '权益类型', prop: 'memberBenefit', align: 'center', slot: 'benefit_type' },
					{ label: '权益板块', prop: 'memberBenefitGroup', align: 'center' },
					{ label: '权益类型', prop: 'memberBenefitName', align: 'center' },
					{ label: '使用时间', prop: 'createTime', align: 'center' }
				],
				// 分页配置
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				},
				// 加载状态
				loading: false
			}
		},
		computed: {
			// 使用自定义的映射函数
			...mapDictionaries('dictionary', ['benefitsTypeDict'])
		},
		watch: {},
		created() {},
		mounted() {
			console.log('benefitsTypeDict:', this.benefitsTypeDict)

			this.handleGetBenefitRecordList()
		},
		methods: {
			// 查询我的权益使用记录
			handleGetBenefitRecordList() {
				this.loading = true

				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					...this.searchForm
				}

				queryMemberBenefitUseRecord(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.recordList = data.records || []
							this.pageOptions.total = data.total || 0
						} else {
							this.recordList = []
							this.total = 0
						}
						this.loading = false
					})
					.catch(() => {
						this.loading = false
						this.recordList = []
						this.total = 0
					})
			},

			// 根据权益类型编码获取权益类型名称
			getBenefitTypeName(code) {
				if (!code) return ''

				const found = this.benefitsTypeDict.find(item => item.dictCode === code)
				return found ? found.dictValue : code
			},

			// 分页
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.handleGetBenefitRecordList()
			},

			// 搜索
			handleSearch() {
				this.pageOptions.page = 1
				this.pageOptions.limit = 10
				this.handleGetBenefitRecordList()
			},

			// 重置搜索
			handleResetSearch() {
				this.searchForm = {
					memberBenefit: '',
					startTime: '',
					endTime: ''
				}
				this.handleGetBenefitRecordList()
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';

	.user-center-content {
		.link {
			padding: 5px 0;
			text-align: right;
		}
		.term-link {
			color: #236fca;
			text-decoration: none;
			margin: 0 3px;

			&:hover {
				text-decoration: underline;
			}
		}
	}
</style>
